import React, { ComponentType, VFC } from 'react';
import { Route, RouteComponentProps, RouteProps } from 'react-router-dom';
import BaseLayout from '../Layouts/BaseLayout';

interface Props extends RouteProps {
  component: ComponentType<RouteComponentProps<any>> | ComponentType<any>;
  displayFooter?: boolean;
}
const BaseLayoutRoute: VFC<Props> = ({
  component: Component,
  displayFooter = true,
  ...rest
}: Props) => {
  return (
    <Route
      {...rest}
      render={(matchedProps) => (
        <BaseLayout displayFooter={displayFooter}>
          <Component {...matchedProps} />
        </BaseLayout>
      )}
    />
  );
};

export default BaseLayoutRoute;
